import { useEffect } from "react";

// Adds .is-visible to any element with .reveal once it enters the viewport.
export default function useReveal() {
    useEffect(() => {
        const els = document.querySelectorAll(".reveal");
        if (!els.length) return;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("is-visible");
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.15 }
        );
        els.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);
}
